const CandidateWorkExperienceStatus = {
  InEmploy: "IN_EMPLOY",
  Resignation: "RESIGNATION"
};

export { CandidateWorkExperienceStatus };
//# sourceMappingURL=candidate-work-experience-status.mjs.map
